import "./App.css";
import { Analytics } from "@vercel/analytics/react"
import {useState, useEffect} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TransitionGroup } from "react-transition-group";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Loader from './components/Loader.jsx'
import Featured from "./pages/Featured";
import Careers from "./pages/Careers";
import MeetTheTeam from "./pages/MeetTheTeam";
import Contact from "./pages/ContactTest";
import OurStory from "./pages/OurStory";
import OurMission from "./pages/OurMission";
import OurWork from "./pages/OurWork";
import InProgress from "./pages/InProgress";
import Future from "./pages/Future";
import Project from "./pages/Project";
import images from "./data/projectImages.js"
import HomePage from "./pages/HomePage.jsx";

function App() {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const hasVisited = sessionStorage.getItem("hasVisited");

    if (!hasVisited) {
      setShowLoader(true);
      sessionStorage.setItem("hasVisited", "true");

      setTimeout(() => {
        setShowLoader(false);
      }, 1200); 
    }
  }, []);

  if (showLoader) return <Loader />;

  return (
    <div className="overflow-x-hidden w-full">
      <BrowserRouter>
        <TransitionGroup>
        <Routes>
          <Route index element={<Home />} />
          {/* <Route index element={<HomePage />} /> */}
          <Route path="*" element={<Home />} />
          {/* <Route path="*" element={<HomePage />} /> */}
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/featured-projects" element={<Featured />} />
          <Route path="/home" element={<Home />} />
          <Route path="/our-team" element={<MeetTheTeam />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/our-mission" element={<OurMission />} />
          <Route path="/projects" element={<Featured />} />
          <Route path="/portfolio" element={<Projects />} />
          <Route path="/in-progress" element={<InProgress />} />
          <Route path="/future-work" element={<Future />} />
  
          <Route
            path="/twenty-two-liberty-@-fan-pier"
            element={
              <Project
              images={images["22Liberty"]}
                name="Twenty Two Liberty @ Fan Pier"
                city="Boston"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/55-park-street"
            element={
              <Project
              images={images["55Park"]}
                name="55 Park Street"
                city="New Haven"
                state="CT"
                type="Medical"
              />
            }
          />
          <Route
            path="/88-seaport"
            element={
              <Project
                images={images["88Seaport"]}
                name="88 Seaport"
                city="Boston"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/100-college-st"
            element={
              <Project
              images={images["100College"]}
                name="100 College Street"
                city="New Haven"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/101-college-st"
            element={
              <Project
              images={images["101College"]}
                name="101 College Street"
                city="New Haven"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/105-west-1st-street"
            element={
              <Project
                images={images["105West1st"]}
                name="105 West 1st Street"
                city="Boston"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/121-broadway"
            element={
              <Project
                images={images["121Broadway"]}
                name="121 Broadway"
                city="Cambridge"
                state="MA"
                type="Residential"
              />
            }
          />
          <Route
            path="/380-stuart-street"
            element={
              <Project
                images={images["380Stuart"]}
                name="380 Stuart Street"
                city="Boston"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/888-boylston-street"
            element={
              <Project
              images={images["888Boylston"]}
                name="88 Boylston Street"
                city="Boston"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/150-2nd-street"
            element={
              <Project
              images={images["1502ndSt"]}
                name="150 2nd Street"
                city="Cambridge"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/back-bay-tower"
            element={
              <Project
              images={images["BackBay"]}
                name="Back Bay Tower"
                city="Boston"
                state="MA"
                type="Commercial"
              />
            }
          />
          <Route
            path="/290/250-binney-street"
            element={
              <Project
              images={images["Binney"]}
                name="290/250 Binney Street"
                city="Cambridge"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/boston-medical"
            element={
              <Project
                images={images["BostonMed"]}
                name="Boston Medical"
                city="Boston"
                state="MA"
                type="Medical"
              />
            }
          />

          <Route
            path="/brigham-&-women's-faulkner-hospital-tower"
            element={
              <Project
              images={images["BrighamWomens"]}
                name="Brigham & Women's Faulkner Hospital Tower"
                city="Boston"
                state="MA"
                type="Medical"
              />
            }
          />
          <Route
            path="/brigham-&-women's-faulkner-hospital-garage"
            element={
              <Project
              images={images[""]}
                name="Brigham & Women's Faulkner Hospital Garage"
                city="Boston"
                state="MA"
                type="Medical"
              />
            }
          />
          <Route
            path="/brown-university-danoff-laboratory"
            element={
              <Project
                images={images["BrownDanoffLab"]}
                name="Brown University Danoff Laboratory"
                city="Providence"
                state="RI"
                type="Education"
              />
            }
          />
          <Route
            path="/brown-university-ilsb"
            element={
              <Project
              images={images["BrownILSB"]}
                name="Brown University ILSB"
                city="Providence"
                state="RI"
                type="Education"
              />
            }
          />
          <Route
            path="/brown-university-indoor-turf-facility"
            element={
              <Project
              images={images["BrownITF"]}
                name="Brown University Indoor Turf Facility"
                city="Providence"
                state="RI"
                type="Education"
              />
            }
          />
          <Route
            path="/bryant-university-george-e.-bello-center"
            element={
              <Project
              images={images["BryantBelloCenter"]}
                name="Bryant University George E. Bello Center"
                city="Smithfield"
                state="RI"
                type="Education"
              />
            }
          />
          <Route
            path="/boston-university-school-of-dental-medicine"
            element={
              <Project
              images={images["BUDentalSchool"]}
                name="Boston University School of Dental Medicine"
                city="Boston"
                state="MA"
                type="Education"
              />
            }
          />
          <Route
            path="/bulfinch-crossing"
            element={
              <Project
              images={images["BulfinchCrossing"]}
                name="Bulfinch Crossing"
                city="Boston"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/danbury-hospital"
            element={
              <Project
              images={images["DanburyHospital"]}
                name="Danbury Hospital"
                city="Danbury"
                state="CT"
                type="Medical"
              />
            }
          />
          <Route
            path="/the-dunkin'-donuts-center"
            element={
              <Project
              images={images["DunkinDonutsCenter"]}
                name="The Dunkin' Donuts Center"
                city="Providence"
                state="RI"
                type="Commercial"
              />
            }
          />
          <Route
            path="/eataly"
            element={
              <Project
              images={images["Eataly"]}
                name="Eataly"
                city="Boston"
                state="MA"
                type="Commercial"
              />
            }
          />
          <Route
            path="/fenway-center-phase-ii"
            element={
              <Project
              images={images["FenwayCenterP2"]}
                name="Fenway Center Phase II"
                city="Boston"
                state="MA"
                type="Commercial"
              />
            }
          />
          <Route
            path="/foxwoods-resort-hotel-&-casino"
            element={
              <Project
              images={images["Foxwoods"]}
                name="Foxwoods Resort Hotel & Casino"
                city="Ledyard"
                state="CT"
                type="Commercial"
              />
            }
          />
          <Route
            path="/google-headquarters"
            element={
              <Project
              images={images["GoogleHQ"]}
                name="Google Headquarters"
                city="Cambridge"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/great-wolf-resorts"
            element={
              <Project
              images={images["GreatWolf"]}
                name="Great Wolf Resorts"
                city="Ledyard"
                state="CT"
                type="Commercial"
              />
            }
          />
          <Route
            path="/harvard-erc-east-&-west-labs"
            element={
              <Project
              images={images["HarvardERC"]}
                name="Harvard ERC East & West Labs"
                city="Boston"
                state="MA"
                type="Education"
              />
            }
          />
          <Route
            path="/knights-of-columbus"
            element={
              <Project
              images={images["Knights"]}
                name="Knights of Columbus"
                city="New Haven"
                state="CT"
                type="Office"
              />
            }
          />
          <Route
            path="/mass-general-hospital"
            element={
              <Project
              images={images["MassGeneralP2"]}
                name="Mass General Hospital"
                city="Boston"
                state="MA"
                type="Medical"
              />
            }
          />
          <Route
            path="/mass-general-brigham-hospital-phase-2"
            element={
              <Project
              images={images["MGHPhase2"]}
                name="Mass General Brigham Hospital Phase 2"
                city="Boston"
                state="MA"
                type="Medical"
              />
            }
          />
          <Route
            path="/mass-mutual-@-fan-pier"
            element={
              <Project
              images={images["MassMutualFanPier"]}
                name="Mass Mutual @ Fan Pier"
                city="Boston"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/mgm-grand-at-foxwoods"
            element={
              <Project
              images={images["MGM"]}
                name="MGM Grand at Foxwoods"
                city="Ledyard"
                state="CT"
                type="Commercial"
              />
            }
          />
          <Route
            path="/mit-site-5"
            element={
              <Project
              images={images["MITSite5"]}
                name="MIT Site 5"
                city="Cambridge"
                state="MA"
                type="Education"
              />
            }
          />
          <Route
            path="/mohegan-sun-earth-hotel"
            element={
              <Project
              images={images["MoheganSunEarth"]}
                name="Mohegan Sun Earth Hotel"
                city="Uncasville"
                state="CT"
                type="Commercial"
              />
            }
          />
          <Route
            path="/mohegan-sun-tower-hotel"
            element={
              <Project
              images={images["MoheganSunTower"]}
                name="Mohegan Sun Tower Hotel"
                city="Uncasville"
                state="CT"
                type="Commercial"
              />
            }
          />
          <Route
            path="/norwalk-hospital"
            element={
              <Project
              images={images["NorwalkHospital"]}
                name="Norwalk Hospital"
                city="Norwalk"
                state="CT"
                type="Medical"
              />
            }
          />
          <Route
            path="/parcel-g"
            element={
              <Project
              images={images["ParcelG"]}
                name="Parcel G"
                city="Cambridge"
                state="MA"
                // type="???"
              />
            }
          />
          <Route
            path="/providence-college-school-of-business"
            element={
              <Project
              images={images["PCBusinessSchool"]}
                name="Providence College School of Business"
                city="Providence"
                state="RI"
                type="Education"
              />
            }
          />
          <Route
            path="/providence-college-friar-center"
            element={
              <Project
              images={images["PCFriarCenter"]}
                name="Providence College Friar Center"
                city="Providence"
                state="RI"
                type="Education"
              />
            }
          />
           <Route
            path="/providence-college-school-of-nursing"
            element={
              <Project
                images={images["PCNursingSchool"]}
                name="Providence College School of Nursing"
                city="Providence"
                state="RI"
                type="Education"
              />
            }
          />
          <Route
            path="/pier-4"
            element={
              <Project
              images={images["Pier4"]}
                name="Pier 4"
                city="Boston"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/providence-place-mall"
            element={
              <Project
              images={images["ProvidencePlace"]}
                name="Providence Place Mall"
                city="Providence"
                state="RI"
                type="Commercial"
              />
            }
          />
          <Route
            path="/prudential-center"
            element={
              <Project
              images={images["PrudentialCenter"]}
                name="Prudential Center"
                city="Boston"
                state="MA"
                type="Commercial"
              />
            }
          />
          <Route
            path="/quinnipiac-university-wellness-center"
            element={
              <Project
              images={images["QuinnipiacWellness"]}
                name="Quinnipiac University Wellness Center"
                city="Hamden"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/ragon-institute-ii"
            element={
              <Project
              images={images["RagonInstituteII"]}
                name="Ragon Institute II"
                city="Cambridge"
                state="MA"
                type="Education"
              />
            }
          />
          <Route
            path="/sacred-heart-university-hockey-arena"
            element={
              <Project
              images={images["SHUHockey"]}
                name="Sacred Heart University Hockey Arena"
                city="Fairfield"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/sacred-heart-university-merton-hall-dorm"
            element={
              <Project
              images={images["SHUMerton"]}
                name="Sacred Heart University Merton Hall Dorm"
                city="Fairfield"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/sacred-heart-university-seton-hall-dorm"
            element={
              <Project
              images={images["SHUSeton"]}
                name="Sacred Heart University Seton Hall Dorm"
                city="Fairfield"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/south-street-landing"
            element={
              <Project
              images={images["SouthStreetLanding"]}
                name="South Street Landing"
                city="Providence"
                state="RI"
                type="Office"
              />
            }
          />
          <Route
            path="/umass-new-inpatient-tower"
            element={
              <Project
              images={images["UMassInpatient"]}
                name="UMass New Inpatient Tower"
                city="Worcester"
                state="MA"
                type="Medical"
              />
            }
          />
          <Route
            path="/umass-medical-school-nerb"
            element={
              <Project
              images={images["UMassNERB"]}
                name="UMass Medical School NERB"
                city="Worcester"
                state="MA"
                type="Education"
              />
            }
          />
          <Route
            path="/uri-college-of-engineering"
            element={
              <Project
              images={images["URIEngn"]}
                name="URI College of Engineering"
                city="South Kingston"
                state="RI"
                type="Education"
              />
            }
          />
          <Route
            path="/volpe-c3"
            element={
              <Project
                images={images["VolpeC3"]}
                name="Volpe C3"
                city="Cambridge"
                state="MA"
                type="Office"
              />
            }
          />
          <Route
            path="/white-plains-hospital-medical-center"
            element={
              <Project
              images={images["WhitePlainsHospital"]}
                name="White Plains Hospital Medical Center"
                city="White Plains"
                state="NY"
                type="Medical"
              />
            }
          />
          <Route
            path="/women-&-infants-hospital"
            element={
              <Project
              images={images["WomenInfants"]}
                name="Women & Infants Hospital"
                city="Providence"
                state="RI"
                type="Medical"
              />
            }
          />
          <Route
            path="/yale-university-graduate-housing"
            element={
              <Project
              images={images["YaleGradHousing"]}
                name="Yale University Graduate Housing"
                city="New Haven"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/yale-kline-tower"
            element={
              <Project
              images={images["YaleKline"]}
                name="Yale Kline Tower"
                city="New Haven"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/yale-new-haven-hospital-neuroscience-bed-tower"
            element={
              <Project
              images={images["YaleNewHaven"]}
                name="Yale New Haven Hospital Neuroscience Bed Tower"
                city="New Haven"
                state="CT"
                type="Medical"
              />
            }
          />
          <Route
            path="/yale-peabody-museum"
            element={
              <Project
              images={images["YalePeabody"]}
                name="Yale Peabody Museum"
                city="New Haven"
                state="CT"
                type="Commercial"
              />
            }
          />
          <Route
            path="/yale-smilow-cancer-center"
            element={
              <Project
              images={images["YaleSmilow"]}
                name="Yale Smilow Cancer Center"
                city="New Haven"
                state="CT"
                type="Medical"
              />
            }
          />
          <Route
            path="/yale-university-wright-lab-building"
            element={
              <Project
              images={images["YaleWrightLab"]}
                name="Yale University Wright Lab Building"
                city="New Haven"
                state="CT"
                type="Education"
              />
            }
          />







{/* CHECK ON THESE */}
          <Route
            path="/quinnipiac-university-school-of-business"
            element={
              <Project
              images={images[""]}
                name="Quinnipiac University School of Business"
                city="Hamden"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/quinnipiac-university-academic-building"
            element={
              <Project
              images={[""]}
                name="Quinnipiac University Academic Building"
                city="Hamden"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/sacred-heart-university-north-dorm"
            element={
              <Project
              images={images[""]}
                name="Sacred Heart University North Dorm"
                city="Fairfield"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/volpe-department-of-transportation"
            element={
              <Project
              images={[""]}
                name="Volpe Department of Transportation"
                city="Cambridge"
                state="MA"
                // type="Education"
              />
            }
          />
          <Route
            path="/yale-bct"
            element={
              <Project
              images={[""]}
                name="Yale BCT"
                city="New Haven"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/brigham-&-women's-faulkner-hospital"
            element={
              <Project
              images={images["BrighamWomens"]}
                name="Brigham & Women's Faulkner Hospital"
                city="Boston"
                state="MA"
                type="Medical"
              />
            }
          />
          <Route
            path="/yale-new-haven-hospital"
            element={
              <Project
              images={images["YaleNewHaven"]}
                name="Yale New Haven Hospital"
                city="New Haven"
                state="CT"
                type="Medical"
              />
            }
          />
          <Route
            path="/stamford-hospital"
            element={
              <Project
              images={images["StamfordHospital"]}
                name="Stamford Hospital"
                city="Stamford"
                state="CT"
                type="Medical"
              />
            }
          />
          <Route
            path="/uconn-gant-renovation"
            element={
              <Project
              images={images["UCONNGant"]}
                name="UCONN Gant Renovation"
                city="Storrs"
                state="CT"
                type="Education"
              />
            }
          />
          <Route
            path="/uconn-stem-research-center"
            element={
              <Project
              images={images["UCONNStem"]}
                name="UCONN Stem Research Center"
                city="Storrs"
                state="CT"
                type="Education"
              />
            }
          /> 
        </Routes>
        <Analytics />
        </TransitionGroup>
      </BrowserRouter>
    </div>
  );
}

export default App;
